import { defineComponent as _defineComponent } from 'vue'
import { User } from '@/interfaces/vuex/user';
import { ref, watch } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDeactivateDialog',
  props: {
    value: { type: Boolean },
    user: null
  },
  emits: ["input", "deactivate"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'deactivate', userUuid: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  user?: User;
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  title: 'ユーザーの無効化',
  confirmMessage: 'ユーザーを無効化しますか？',
  description:
    '無効化されたユーザーは強制ログアウトされ、再度有効化されるまでログインできません。',
  deactivateButton: '無効化する',
});





const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

watch(
  () => localValue.value,
  (newValue) => {
    emit('input', newValue);
  }
);

const closeDialog = () => {
  emit('input', false);
};

const handleDeactivateClick = async () => {
  if (!props.user) {
    throw new Error('User is required');
  }
  emit('deactivate', props.user.uuid);
  closeDialog();
};

return { __sfc: true,$t, m, props, emit, localValue, closeDialog, handleDeactivateClick, BaseFormCard, sharedMessages }
}

})